import { graphql } from 'src/graphql';

import type { ResultOf } from 'src/graphql';

export const ManagedTagFields = graphql(`
  fragment ManagedTagFields on TagType @_unmask {
    _id
    name
    color
    description
    highlight_ids
  }
`);

/** The API loads every tag of the team on each request whatever `first` is, so one page holds them all. */
export const ManagedTags = graphql(
  `
    query ManagedTags($teamId: ID!) {
      tags(filter: { _team_id: { eq: $teamId } }, first: 10000) {
        nodes {
          ...ManagedTagFields
        }
      }
    }
  `,
  [ManagedTagFields],
);

export type ManagedTag = ResultOf<typeof ManagedTagFields>;
